import { render } from "./SupportCaseDropdown.vue?vue&type=template&id=18ac1c0e&ts=true"
import script from "./SupportCaseDropdown.vue?vue&type=script&lang=ts"
export * from "./SupportCaseDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__